/** ***********************************************************************
 *
 * Copyright 2020 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ************************************************************************* */

import React, { Component } from 'react';
import { observer } from 'mobx-react';
import TutorialHeader from './tutorialHeader';
import TutorialCard from './tutorialCard';
import { PDP_ACTION, PDP_SECTION } from '../../../../utils/pdpUtils/pdpEnums';
import ContentParser from '../../../../utils/contentParser';

class Tutorials extends Component {
    get tutorialsData() {
        const { PDPDataObject } = this.props;
        return this.validataAndProcessData(PDPDataObject);
    }

    validateTutorial(tutorial, localAssetsBasePath) {
	    return (ContentParser.getAssetPath(tutorial.image, localAssetsBasePath) && tutorial.name
		 && tutorial.durationInMinutes);
    }

    validataAndProcessData({ contentfulData, localAssetsBasePath }) {
	    if (!contentfulData.tutorialList
			|| !contentfulData.tutorialList.length
			|| !contentfulData.tutorialTitle) {
	        return null;
        }
	    const tutorialListModel = [];
	    // eslint-disable-next-line
	    contentfulData.tutorialList && contentfulData.tutorialList.forEach((value, key) => {
	        // eslint-disable-next-line
	        this.validateTutorial(value,localAssetsBasePath) && tutorialListModel.push({
	            actionId: PDP_ACTION.TUTORIAL_CLICK,
	            imageURL: ContentParser.getAssetPath(value.image, localAssetsBasePath),
	            description: value.name,
	            numOfTutorials: value.numberOfTutorials,
	            tutorialURL: (value.link && value.link.url),
	            urlData: value.link,
                duration: value.durationInMinutes,
                ingestDescription: value.ingestDescription,
	        });
	    });

	    const tutorialModel = {
	        sectionId: PDP_SECTION.TUTORIALS,
	        sectionName: contentfulData.tutorialTitle,
	        viewMore: {},
	        tutorialList: tutorialListModel,
	    };
	    if (contentfulData.moreTutorialsLink && contentfulData.moreTutorialsLink.url) {
	        tutorialModel.viewMore = {
	            actionId: PDP_ACTION.VIEW_MORE_CLICK,
	            url: contentfulData.moreTutorialsLink.url,
	            urlData: contentfulData.moreTutorialsLink,
	        };
	    }
	    return tutorialModel;
    }

    renderTutorialCards() {
        const {
            PDPDataObject: {
                actionHandlerCallback,
            },
        } = this.props;
        const { tutorialList, sectionId } = this.tutorialsData;
        return tutorialList.map(tutorialCardConfig => (
            <TutorialCard
                sectionId={sectionId}
                tutorialCardConfig={tutorialCardConfig}
                key={tutorialCardConfig.description}
                actionHandlerCallback={actionHandlerCallback} />
        ));
    }

    render() {
        const { PDPDataObject } = this.props;
        const { actionHandlerCallback } = PDPDataObject;
        const data = {
            tutorials: this.tutorialsData,
            actionHandlerCallback,
        };

        return this.tutorialsData && (
            <div className="tutorial-section  left-panel-compt">
                <TutorialHeader data={data} />
                <div className="tutorial-cards">
                    {this.renderTutorialCards()}
                </div>
            </div>
        );
    }
}

export default observer(Tutorials);
